import {Button, DateInput, List, ListProps, TextInput,} from "ra-ui-materialui";
import {useOptions} from "../../shared/hooks/useOptions";
import {Box, Grid, Paper, Tab, Tabs} from "@material-ui/core";
import {FileRowDatagrid} from "./FileRowDatagrid";
import {ReconciliationJournalEntryDatagrid} from "./ReconciliationJournalEntryDatagrid";
import {useState} from "react";
import {client} from "../../dataProvider";
import {ReconciliationDatagrid} from "./ReconciliationDatagrid";
import {initField} from "../../shared/utils";


function TabPanel(props: any) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}


export const ReconciliationList = (props: ListProps) => {
    const {data: optionsR} = useOptions("file_row", "GET");
    const {data: optionsJ} = useOptions("reconciliation_journal_entry", "GET");
    const {data: options} = useOptions("reconciliation", "GET");
    const [value, setVaule] = useState(0)
    const [selectJournalEntry, setSelectJournalEntry] = useState<any[]>([]);
    const [selectFileRow, setSelectFileRow] = useState<any[]>([]);


    const filetrReconciliation = options && [
        <TextInput {...initField("id", options)} label="Id"/>,
        <DateInput
            {...initField("date", options)}
            label="Data"
        />,
    ];

    const handleClick = () => {
        client(`reconciliation/create_reconciliation`, {
            method: "POST",
            data: {
                idsJournalEntry: selectJournalEntry,
                idsFileRow: selectFileRow,
            }
        }).then(() => {
            window.location.reload();
        }).catch(() => {
            alert("Errore")
        });
    }

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setVaule(newValue);
    };
    return optionsR && optionsJ ? (


        <Paper square>
            <Tabs
                value={value}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
            >
                <Tab label="Riconciliazione"/>
                <Tab label="Righe riconciliate"/>
            </Tabs>
            <TabPanel value={value} index={0}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Button label="Riconcilia" onClick={handleClick}
                                disabled={selectJournalEntry.length === 0 || selectFileRow.length === 0}></Button>
                    </Grid>
                    <Grid item xs={6} style={{maxWidth: "50%"}}>
                        <h1>Prima nota</h1>
                        <List
                            {...props}
                            resource="reconciliation_journal_entry"
                            exporter={false}
                            bulkActionButtons={false}
                            syncWithLocation={false}
                            title="Ric"
                            perPage={100}
                        >
                            <ReconciliationJournalEntryDatagrid
                                options={optionsJ}
                                selectedRow={selectJournalEntry}
                                setFileRow={setSelectFileRow}
                                setSelectJournalEntry={setSelectJournalEntry}
                            />
                        </List>
                    </Grid>
                    <Grid item xs={6} style={{maxWidth: "50%"}}>
                        <h1>Movimenti bancari</h1>
                        <List
                            {...props}
                            resource="file_row"
                            exporter={false}
                            bulkActionButtons={false}
                            syncWithLocation={false}
                            title="onciliazione"
                            perPage={100}>
                            <FileRowDatagrid
                                options={optionsR}
                                selectedRow={selectFileRow}
                                setSelectJournalEntry={setSelectJournalEntry}
                                setSelectFileRow={setSelectFileRow}
                            />
                        </List>
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <List exporter={false} filters={filetrReconciliation} {...props}>
                    <ReconciliationDatagrid options={options}/>
                </List>
            </TabPanel>
        </Paper>


    ) : null;
};